import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import HeaderBanner from "./HeaderBanner";

const Header = () => <HeaderBanner />;

export default Header;